import { AUTH, PRESCREENING, ROUTE } from '@/constants';
import { loadView } from '../index';

const DashboardView = loadView('dashboard/DashboardView');

const dashboardRoute = {
  path: ROUTE.PATH.DASHBOARD,
  component: () => import('@/layouts/default/DefaultLayout.vue'),
  meta: {
    auth: AUTH.USER_ROLE.AUTHORIZED,
    tags: [
      PRESCREENING.APPROVAL_KEY.COMPLETED,
      PRESCREENING.APPROVAL_KEY.REJECTED,
      PRESCREENING.APPROVAL_KEY.TODO,
    ],
  },
  children: [
    {
      path: '',
      name: ROUTE.NAME.DASHBOARD,
      component: DashboardView,
      meta: {
        auth: AUTH.USER_ROLE.AUTHORIZED,
        tags: [
          PRESCREENING.APPROVAL_KEY.COMPLETED,
          PRESCREENING.APPROVAL_KEY.REJECTED,
          PRESCREENING.APPROVAL_KEY.TODO,
        ],
      },
    },
  ],
};

export default dashboardRoute;
